import React, { useState } from "react";
import "./App.css";
import { authProvider } from "./authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import AppContextProvider from "./context";
import { getCachedThemeDetails, setThemeDetailsToCache } from "./api/addUser";
import { setAxiosInterCeptor } from "./api/axios";
import LoadingSpinner from "./components/Reusables/LoadingSpinner.jsx";
import { APP_CONSTANTS } from "./constants/app-constants.js";
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';



function App() {
	datadogRum.init({
    applicationId: process.env.REACT_APP_DATA_DOG_APP_ID,
    clientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN,
    site: process.env.REACT_APP_DATA_DOG_SITE,
    service: process.env.REACT_APP_DATA_DOG_SERVICE,
    env: process.env.REACT_APP_DATA_DOG_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
});
	const [isDarkMode, setIsDarkMode] = useState(getCachedThemeDetails() ?? false);

	const theme = createTheme({
		palette: {
			mode: isDarkMode ? "dark" : "light",
			background: {
				default: isDarkMode ? "#101418" : "#FFFFFF",
				paper: isDarkMode ? "#101418" : "#FFFFFF",
			},
			text: {
				primary: isDarkMode ? "#FFFFFF" : "#1D1B20",
				secondary: isDarkMode ? "#A9A9A9" : "#1D1B20",
				button: isDarkMode ? "#FFFFFF" : "#006098",
				buttonhover: isDarkMode ? "#FFFFFF" : "#FFFFFF",
			},
			primary: { main: isDarkMode ? "#101418" : "#E8F2FF" },
            breadcumb: {primary: isDarkMode ? "#e8f2ff80" : "#E8F2FF"},
			secondary: { main: isDarkMode ? "#2D3135" : "#FFFFFF" },
			button: { main: isDarkMode ? "#2D3135" : "#006098" },
			buttonhover: { main: isDarkMode ? "#004766" : "#004766" },
			border: { main: isDarkMode ? "1px solid #FFFFFF" : "1px solid #006098" },
			FocusStyle: { main: isDarkMode ? "#FFFFFF" : "#006098" },
			tabbtn: { main: isDarkMode ? "#A9A9A9" : "#101418" },
		},
	});

	const handleThemeChange = () => {
		setThemeDetailsToCache(!isDarkMode);
		setIsDarkMode(!isDarkMode);
	};

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AppContextProvider>
				<div>
					<AzureAD provider={authProvider}>
						{(azureProps) => {
							const { authenticationState, login } = azureProps;
							if (authenticationState === AuthenticationState.Authenticated) {
                                azureProps.accountInfo.jwtIdToken && setAxiosInterCeptor({token: azureProps.accountInfo.jwtIdToken});
								return <AuthenticatedRoute {...azureProps} onThemeChange={handleThemeChange} />;
							} else if (authenticationState === AuthenticationState.InProgress) {
								return <LoadingSpinner loaderMessage={APP_CONSTANTS.LOADING_MESSAGE} />;
							} else {
								login()
								return null;
							}							
						}}
					</AzureAD>
				</div>
			</AppContextProvider>
		</ThemeProvider>
	);
}

export default App;
